import useDesignTokens from '@assetron/web-common/themes/useDesignTokens';
import { useTheme } from '@mui/material/styles';
import { useMemo } from 'react';

const useSigninEnterPasswordContentStyles = () => {
  const theme = useTheme();
  const tokens = useDesignTokens();

  const styles = useMemo(
    () => ({
      root: {
        width: '360px',
        maxWidth: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'stretch',
        textAlign: 'center',
        alignContent: 'flex-start',
        marginTop: theme.sizeGuide['4xl'],
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: theme.sizeGuide.none,
        },
      },
      passkeyRoot: {
        width: '384px',
        maxWidth: '100%',
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        alignContent: 'flex-start',
        marginTop: theme.sizeGuide['4xl'],
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: theme.sizeGuide.none,
        },
      },
      emailContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.lg,
        [theme.breakpoints.down('sm')]: {
          gap: theme.sizeGuide.sm,
        },
      },
      emailContainerResetPassword: {
        display: 'flex',
        flexDirection: 'column',
        marginBottom: theme.sizeGuide['2xl'],
        gap: theme.sizeGuide.lg,
        [theme.breakpoints.down('sm')]: {
          gap: theme.sizeGuide.sm,
        },
      },
      rootEnterEmail: {
        width: '360px',
        marginTop: theme.sizeGuide['4xl'],
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        textAlign: 'center',
        gap: theme.sizeGuide.lg,
        [theme.breakpoints.down('sm')]: {
          width: '100%',
        },
      },
      textContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        gap: theme.sizeGuide.sm,
        marginBottom: theme.sizeGuide['2xl'],
      },
      loadingState: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        minHeight: theme.sizeGuide['7xl'],
      },
      passkeyTextContentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.sizeGuide.xs,
        marginBottom: theme.sizeGuide.xl,
      },
      passwordContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.sizeGuide['2xl'],
        paddingBottom: theme.sizeGuide['3xl'],
      },
      passkeyPromptBody: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'stretch',
        marginTop: theme.sizeGuide.lg,
      },
      passkeyPromptHint: {
        width: '100%',
        minHeight: theme.sizeGuide['6xl'],
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: tokens.radius.xs,
        backgroundColor: tokens.colors.bg.secondary,
        color: tokens.colors.text.secondary,
        padding: theme.sizeGuide.lg,
      },
      emailText: {
        wordWrap: 'break-word',
        color: tokens.colors.text.secondary,
      },
      passkeySubtitle: {
        color: tokens.colors.text.secondary,
        wordWrap: 'break-word',
      },
      passkeyEmailSpacer: {
        height: theme.sizeGuide.lg,
      },
      button: {
        marginTop: theme.sizeGuide.lg,
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: theme.sizeGuide.none,
        },
      },
      buttonGroup: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.sizeGuide.md,
        marginTop: theme.sizeGuide.lg,
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: theme.sizeGuide.none,
        },
      },
      passkeyButtonGroup: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: theme.sizeGuide.lg,
        marginTop: 'auto',
        marginBottom: theme.sizeGuide['4xl'],
        [theme.breakpoints.down('sm')]: {
          width: '100%',
          marginBottom: theme.sizeGuide.none,
        },
      },

      nextButtonText: {
        paddingTop: theme.sizeGuide.lg,
        paddingBottom: theme.sizeGuide.lg,
        textTransform: 'none',
      },
      passwordFallbackLink: {
        color: tokens.colors.fg.highlight.primary,
        cursor: 'pointer',
        textAlign: 'center',
        textDecoration: 'underline',
        marginBottom: theme.sizeGuide.xs,
        border: 'none',
        background: 'transparent',
        padding: theme.sizeGuide.none,
        font: 'inherit',
      },
    }),
    [theme, tokens],
  );

  return styles;
};

export default useSigninEnterPasswordContentStyles;
